module.exports = __webpack_public_path__ + "img/italic.431c4f8a.svg";